function isScriptLoaded(url) {
    return Array.from(document.scripts).some(script => script.src.includes(url));
}

export function loadScript(src) {
    return new Promise(function (resolve, reject) {
        if (!isScriptLoaded(src)) {
            const scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = src;
            scriptElement.onload = resolve;
            scriptElement.onerror = reject;
            document.head.appendChild(scriptElement);
        } else {
            resolve();
        }
    });
}